<template>
    <el-popover
        placement="right"
        :width="320"
        trigger="hover"
        popper-class="credits-popover"
    >
        <template #reference>
            <PtIcon icon="SolidInfo" class="flex-shrink-0 cursor-pointer text-xl fill-[#BCC2CC] hover:fill-[#8993A4]"></PtIcon>
        </template>
        <template #default>
            <div class="flex flex-col gap-3">
                <div class="text-base font-medium leading-[1.5] text-[#020A1A]">
                    {{ t('credits.tooltip.title') }}
                </div>
                <div class="flex flex-col gap-2">
                    <div class="flex items-center justify-between">
                        <span class="text-sm leading-[1.43] text-[#495973]">{{ t('credits.tooltip.daily') }}</span>
                        <span class="text-sm leading-[1.43] text-[#020A1A]">{{ creditsPerMonth?.available || 0 }}</span>
                    </div>
                    <div class="flex items-center justify-between">
                        <span class="text-sm leading-[1.43] text-[#495973]">{{ t('credits.tooltip.rewarded') }}</span>
                        <span class="text-sm leading-[1.43] text-[#020A1A]">{{ earnCredits?.available || 0 }}</span>
                    </div>
                    <div class="flex items-center justify-between">
                        <span class="text-sm leading-[1.43] text-[#495973]">{{ t('credits.tooltip.purchased') }}</span>
                        <span class="text-sm leading-[1.43] text-[#020A1A]">{{ addonCredits?.available || 0 }}</span>
                    </div>
                </div>
                <el-divider class="!my-2" />
                <div class="text-xs leading-[1.67] text-[#8993A4]" v-safe-html="consumptionDesc">
                </div>
            </div>
        </template>
    </el-popover>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import { ElPopover, ElDivider } from 'element-plus';
import { PtIcon } from 'patsnap-biz';
import '@patsnap-ui/icon/assets/solid/info.svg';
import { useLsEditionUsage } from '../../../composables/use-ls-edition-usage';
import { PLAN_CONFIG } from '../../../constants';
import { computedAsync } from '@vueuse/core';

const messages = {
    en: {
        credits: {
            tooltip: {
                title: 'Available Credits',
                daily: 'Daily (Refilling)',
                rewarded: 'Rewarded',
                purchased: 'Purchased',
                description: 'Restores {credits}/hr when below limit. Daily resets at <span class="whitespace-nowrap">0:00</span>.',
            },
        },
    },
    cn: {
        credits: {
            tooltip: {
                title: '可用积分',
                daily: '每日（自动补充）',
                rewarded: '奖励积分',
                purchased: '购买积分',
                description: '低于限额时每小时恢复 {credits} 积分。每日 <span class="whitespace-nowrap">0:00</span> 重置。',
            },
        },
    },
    tw: {
        credits: {
            tooltip: {
                title: '可用積分',
                daily: '每日（自動補充）',
                rewarded: '獎勵積分',
                purchased: '購買積分',
                description: '低於限額時每小時恢復 {credits} 積分。每日 <span class="whitespace-nowrap">0:00</span> 重置。',
            },
        },
    },
    jp: {
        credits: {
            tooltip: {
                title: '利用可能なクレジット',
                daily: '毎日（自動補充）',
                rewarded: '報酬クレジット',
                purchased: '購入クレジット',
                description: '制限を下回る場合、毎時 {credits} クレジット回復。毎日 <span class="whitespace-nowrap">0:00</span> にリセット。',
            },
        },
    },
}

const { t } = useI18n({
    messages,
});

const { creditsPerMonth, earnCredits, addonCredits, userEdition } = useLsEditionUsage();

const consumptionDesc = computedAsync(async() => {
    const currentEdition = userEdition.value;
    const planConfig = PLAN_CONFIG.A;

    return t('credits.tooltip.description', { credits: planConfig[currentEdition].credits });
});
</script>
